import { useDeviceType } from '@cian/ui-kit';

import { type FC } from 'react';

import { useAdfoxBannerContext } from 'shared/components/AdfoxBannerContext';

import { ParallaxGeneral, type TParallaxGeneralProps } from './ParallaxGeneral';

type TParallaxGeneralContainerProps = Omit<TParallaxGeneralProps, 'deviceType' | 'sizes'>;

export const ParallaxGeneralContainer: FC<TParallaxGeneralContainerProps> = props => {
  const { sizes } = useAdfoxBannerContext();
  const deviceType = useDeviceType();

  return <ParallaxGeneral {...props} sizes={sizes} deviceType={deviceType} />;
};
